/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Share_Accessusers2Inputs */

const en_coinvestments_share_accessusers2 = /** @type {(inputs: Coinvestments_Share_Accessusers2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} users`)
};

/**
* | output |
* | --- |
* | "{count} users" |
*
* @param {Coinvestments_Share_Accessusers2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_accessusers2 = /** @type {((inputs: Coinvestments_Share_Accessusers2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Accessusers2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_accessusers2(inputs)
});
export { coinvestments_share_accessusers2 as "coInvestments_share_accessUsers" }